module.exports = __webpack_public_path__ + "static/media/ctc_event_3.e6789337.jpeg";